//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loadMoreBtn from '@/common/components/load-more-btn/index.vue'
// import gameHead from '../components/game-head/index.vue'
// import gameList from './item/index.vue'
import hotGameList from './item/hot.vue'
import Search from '../components/search/index.vue'
import Loading from '../components/loading/index.vue'
import { getPlatformByPlatCode, getAllGameList, getHomeHotGameList } from '@/common/api/game.js'
import { goSlotGame, goGame,goSpecialFishGame, goSpecificGame,fastGoGame} from '@/common/utils/common.js';
import collectMX from './collect-mx.js'
import { mapState } from 'vuex'
import IframeWrap from './iframewrap.vue'

export default {
  components: { Search, loadMoreBtn, IframeWrap,hotGameList,Loading},
  mixins: [collectMX],
  props: {
    gameTypeCode: {
      type: String,
      default: '7'
    }
  },
  data() {
    return {
      SelectId: [], // 已选列表
      SelectIdArr:[], //去重已选列表
      platformCodeString:'', //已选平台字符串
      showPop: false,
      loadingData: true,
      slotClass: '',
      // Loading 控制
      isloading: null,
      platformList: [], // 电子的平台列表
      slotTabIndex: 0, // 电子平台
      gameType: '-1', // 游戏类型
      platformCode: null, // 电子平台
      platform: null, // 平台信息 类似电子一样列表显示的是游戏而不是平台
      loadmore: true,
      finish: Function,
      pages: { pageNo: 1, pageSize: 27 },
      list: [],
      total: null,
      queryType: '',
      queryIndex: 0,
      isShowFriendly: false,
      isLoad: false,
      ifrUrl: '',
      ifrTitle: '',
      //下拉加载
      scrollTop1: 0,
      refreshing: false,
      offset: 50,
      loading: false,
      finished: false,
      timer: null,
      top:false,
      hasNextPage:false,//是否有下一页
      nowNumber: 0,//已经显示多少个
    }
  },
  computed: {
      ...mapState({
          eventPlatFormCode: state => state.eventPlatFormCode
      })
  },
  watch: {
    eventPlatFormCode(newVal, oldVal) {
      if (newVal !== '') {
        const index = this.platformList.findIndex((item)=>{
          return item.platformCode === newVal
        });
        this.slotTabIndex = index
        this.handleSlotPlat(this.platformList[index])
        this.$store.commit('setEventPlatFormCode', '')
      }
    },
    // $route: {
    //     handler(v) {
    //       this.setIfrUrl('')
    //     },
    //     deep: true
    //   }
  },
  created() {
    this.isLoad = true;
    // this.gameType = this.$route.params.id || '-1'
    this.gameType = this.gameTypeCode || '-1'
    if (this.gameType === '1' || this.gameType === '6') this.slotClass = 'slot_'
    if (this.$route.query.platformCode) {
      this.platformCode = this.$route.query.platformCode
    }
    this._getLists() // 获取游戏列表
    setTimeout(()=>{
      const storedArray = sessionStorage.getItem('homeNav');
      if (storedArray) {
          const navList = JSON.parse(storedArray);
          for (const item of navList) {
              if (item.gameType && item.gameType <= 8) {
                  this.preLoad(item.gameType);
              }
          }
      }
    }, 5000)
  },
  methods: {
      preLoad(gameType) {
          if (!sessionStorage.getItem(`gameTypeList${gameType}`)) {
              let _ajax = null
              let params = {}
              if (this.$Cookies.get('UUID')) params.UUID = this.$Cookies.get('UUID') || window.localStorage.getItem('UUID')
              if (gameType === '-1') { // 热门
                  _ajax = getHomeHotGameList
              } else { // 其他
                  _ajax = getPlatformByPlatCode
                  params = { gameType }
              }
              _ajax(params).then(([data, err, res]) => {
                  if (!err && data) {
                      sessionStorage.setItem(`gameTypeList${gameType}`, JSON.stringify(data));
                      if ([1, 2, 5, 6, 7, 8].includes(Number(gameType))) {
                          const params = { gameType, platformCode: '', pageNo: 1, pageSize: 27, hotOrNew: '' }
                          if (this.$store.state.isLogin) params.UUID = this.$store.state.UUID
                          let strKey = ''
                          for (const key in params) {
                              strKey+=`${key}-${encodeURIComponent(params[key])}`
                          }
                          if (!sessionStorage.getItem(`${strKey}`)) {
                              getAllGameList(params).then(([data, err, res]) => {
                                  if (!err) {
                                      sessionStorage.setItem(`${strKey}`, JSON.stringify(data));
                                  }
                              })
                          }
                          
                      }
                  }
              })
          }
      },
    start() {
      this.timer = setTimeout(() => {
        this.timer = null; // 清除计时器
        this.longPress(); // 触发长按事件
      }, 1000); // 设置长按时间为1秒
    },
    end() {
      if (this.timer) {
        clearTimeout(this.timer); // 清除计时器
      }
    },

    loadingShow() {
        let loading = this.$loading({
          text: "Loading",  // 显示文本
          spinner: "el-icon-loading", // 显示的 icon
          background: "rgba(0, 0, 0, 0.7)", // loading 遮罩层颜色
          target: document.querySelector("body"), // 挂载的 DOM 元素
        });
        // 返回的匿名函数
        return () => {
          // 匿名函数返回对象
          return {
            // 控制关闭 Loading 遮罩层
            close: loading.close(),
          };
        };
    },
    showPopup() {
      this.showPop = true;
    },
    setIfrUrl(url) {
      this.ifrUrl = url;
      this.ifrTitle = '';
    },
    handleClick(id) { // 导航点击
     // this.slotTabIndex = index
      if (!this.SelectId.includes(id)) {
        this.SelectId.push(id) // 判断已选列表中是否存在该id，不是则追加进去
      } else {
        let index = this.SelectId.indexOf(id) // 求出当前id的所在位置
        this.SelectId.splice(index, 1) // 否则则删除
      }

     // this.SelectIdArr = this.unique(this.SelectId);
    },
    confirmPlatformList(){        
      const arr = this.SelectId;
      this.platformCodeString = ''; //重置
      for (let i = 0; i < arr.length; i++) {
        this.platformCodeString += arr[i] + ",";
        // if (i < arr.length - 1) {
        //   this.platformCodeString += arr[i] + ",";
        // } else {
        //   this.platformCodeString += arr[i];
        // }
      }
      this.handleSlotPlat(this.platformCodeString)
      //this.handleSlotPlat(this.platformList[this.slotTabIndex])
      this.showPop = false;
    },

    handleSlotPlat({ platformCode, maintain, maintainRemarks ,platformCodeString}) { // 电子平台点击
      this.platformCode = platformCodeString
      this.platform = { maintain, maintainRemarks }
      this.list=[]
       this.pages.pageNo = 1
      this._getSlotList()
    },

    async handleGoGame(item) { // 点击游戏
      // popularType 热门类型0=平台，1=游戏
      // 游戏类型:1 - 电子，2-真人，3-体育，4-彩票，5-捕鱼，6-棋牌
      const { gameType, platformKey, platformCode, popularType, gameId, gameName, platformName,hasShowSubGame } = item
      this.ifrTitle = gameName || platformName || ''
      let lang = 'en'
      if (this.$Cookies.get('lang') === 'hi_IN') lang = 'hi'
      const unlogLinks = { // 未登录游戏嵌套链接
          BBBEXCHANGE:'https://gamet.bbbiframe.com/exchange/in-play',
          IBC2: `https://ismart.l0044.xtu168.com/DepositLogin/bfindex?lang=${lang}&skincolor=rd001`, // 【沙巴体育】
          BTI: `https://prod20144-27818307.1x2aaa.com/${lang}/sports`, // BTI体育
      }

      // if (platformCode === 'BTI') {
      if (platformCode && unlogLinks[platformCode]) {
        // const loadingInstance = this.$loading();
        this.isloading = this.loadingShow();
        // let gameUrl = this.$store.state.isLogin ? goGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : unlogLinks[platformCode]
        // let gameUrl = this.$store.state.isLogin ? await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : unlogLinks[platformCode]
        const res = this.$store.state.isLogin ? await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID , 1) : {gameUrl: unlogLinks[platformCode]}
        let gameUrl = res.gameUrl;
        // loadingInstance.close();
        this.isloading().close;
        if (!gameUrl && platformCode != 'JIUW') {
            this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
            return false
        }
        // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
        if (platformCode === 'JIUW') { //九W游戏外跳
          this.isloading().close;
          goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
        }else{
          this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
        }
        return false
      }

      if (gameType === '4' && platformCode === 'GT') { // 表示跳到彩票
        const type = (platformKey && platformKey.indexOf('GT_LOTTERY_') > -1) ? platformKey.replace('GT_LOTTERY_', '') : '3'
        this.$router.push({ path: '/bet', query: { type } })
        return
      }
      //判断gameId是否有值，有值就直接进游戏，没值就判断hasShowSubGame的值，=1请求小游戏列表  =0进游戏
      if(gameId){
          const { maintain, maintainRemarks } = item // "maintain": "0=没有维护,1=维护中",
          if ((gameType === '1' || gameType === '6' || gameType === '5') && this.platformCode === '') {  // 如果是电子或者棋牌,且进入 all game 选项
            const itemSel = this.platformList.find((item2)=>{
                return item2.platformCode === platformCode
            })
            if (itemSel) {
                if (itemSel.maintain || itemSel.maintain != '1') {
                    if (this.$store.state.isLogin) {
                      let gameUrl = '';
                      let res = {};
                      // const loadingInstance = this.$loading();
                      this.isloading = this.loadingShow();
                      if(gameType === '1'){
                        res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                        gameUrl = res.gameUrl
                        // this.$router.push({ path: '/game/iframe', query: { ifrUrl:gameUrl } })
                      }else if(gameType === '5'){
                        res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                        gameUrl = res.gameUrl
                      }else if(gameType === '6'){
                        res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                        gameUrl = res.gameUrl
                      }else{
                        // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                        res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                        gameUrl = res.gameUrl
                      }
                      // loadingInstance.close();
                      this.isloading().close;
                        if (!gameUrl && platformCode != 'JIUW') {
                            this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                            return false
                        }
                        // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
                        if (platformCode === 'JIUW') { //九W游戏外跳
                          this.isloading().close;
                          goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                        }else{
                          this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                        }
                        return false
                    } else {
                        this.$router.push({ path: '/login' })
                    }
                } else {
                    this.$store.commit('setupholdInfo', maintainRemarks)
                    this.$store.commit('setupholdShow', true) // 维护弹框
                }
                return false
            }
            
          }
          if (maintain != '1') {
            if (this.$store.state.isLogin) {
                let gameUrl = '';
                let res = {};
          // const loadingInstance = this.$loading();
              this.isloading = this.loadingShow();
                if(gameType === '1' || gameType === '7' || gameType === '8'){
                    res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                    gameUrl = res.gameUrl
                }else if(gameType === '5'){
                    res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                    gameUrl = res.gameUrl
                }else if(gameType === '6'){
                    res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                    gameUrl = res.gameUrl
                }else if(gameType === '3'){
                  if (platformCode === 'JIUW') { //九W游戏外跳
                    // loadingInstance.close();
                    this.isloading().close;
                    goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                  }else{
                    // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID) //体育
                    res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //体育
                    gameUrl = res.gameUrl
                  }

                }else{
                    // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                    res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                    gameUrl = res.gameUrl
                }
                if (!(gameType === '3' && platformCode === 'JIUW')) {
                  this.isloading().close;
                }
                if (!gameUrl && platformCode != 'JIUW') {
                  this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                    return false
                }
                // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
                if (platformCode === 'JIUW') { //九W游戏外跳
                  this.isloading().close;
                  goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                }else{
                  this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                }
                return false
            } else {
              this.$router.push({ path: '/login' })
            }
          } else {
            this.$store.commit('setupholdInfo',  maintainRemarks )
            this.$store.commit('setupholdShow', true) // 维护弹框
          }
      }else{
        if(hasShowSubGame == 0 || !hasShowSubGame){
          const { maintain, maintainRemarks } = item // "maintain": "0=没有维护,1=维护中",
          if ((gameType === '1' || gameType === '6' || gameType === '5') && this.platformCode === '') {  // 如果是电子或者棋牌,且进入 all game 选项
            const itemSel = this.platformList.find((item2)=>{
                return item2.platformCode === platformCode
            })
            if (itemSel) {
                if (itemSel.maintain === '0') {
                    if (this.$store.state.isLogin) {
                      let gameUrl = '';
                      let res = {};
                      // const loadingInstance = this.$loading();
                      this.isloading = this.loadingShow();
                      if(gameType === '1'){
                        res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                        gameUrl = res.gameUrl
                        // this.$router.push({ path: '/game/iframe', query: { ifrUrl:gameUrl } })
                      }else if(gameType === '5'){
                        res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                        gameUrl = res.gameUrl
                      }else if(gameType === '6'){
                        res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                        gameUrl = res.gameUrl
                      }else{
                        // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                        res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                        gameUrl = res.gameUrl
                      }
                      // loadingInstance.close();
                      this.isloading().close;
                        if (!gameUrl && platformCode != 'JIUW') {
                            this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                            return false
                        }
                        // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`

                        if (platformCode === 'JIUW') { //九W游戏外跳
                          this.isloading().close;
                          goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                        }else{
                          this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                        }
                        return false
                    } else {
                        this.$router.push({ path: '/login' })
                    }
                } else {
                    this.$store.commit('setupholdInfo', maintainRemarks)
                    this.$store.commit('setupholdShow', true) // 维护弹框
                }
                return false
            }
            
          }
            
          
          if (maintain != '1') {
            if (this.$store.state.isLogin) {
                let gameUrl = '';
                let res = {};
          // const loadingInstance = this.$loading();
          this.isloading = this.loadingShow();
                if(gameType === '1' || gameType === '7' || gameType === '8'){
                    res = await goSlotGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 电子
                    gameUrl = res.gameUrl
                }else if(gameType === '5'){
                    res = await goSpecialFishGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //捕鱼
                    gameUrl = res.gameUrl
                }else if(gameType === '6'){
                    res = await goSpecificGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //棋牌
                    gameUrl = res.gameUrl
                }else if(gameType === '3'){
                  if (platformCode === 'JIUW') { //九W游戏外跳
                    // loadingInstance.close();
                    this.isloading().close;
                    goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                  }else{
                    // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID) //体育
                    res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) //体育
                    gameUrl = res.gameUrl
                  }

                }else{
                    // gameUrl = goGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                    res = await fastGoGame(item, this.$store.state.isLogin, this.$store.state.UUID, 1) // 非电子
                    gameUrl = res.gameUrl
                }
                if (!(gameType === '3' && platformCode === 'JIUW')) {
                  this.isloading().close;
                }
                if (!gameUrl && platformCode != 'JIUW') {
                  this.$vux.toast.show({ text: res.msg || 'Error', type: 'warn' })
                    return false
                }
                // this.ifrUrl = gameUrl.indexOf('http') > -1 ? decodeURIComponent(gameUrl) : `${location.origin}${decodeURIComponent(gameUrl)}`
                if (platformCode === 'JIUW') { //九W游戏外跳
                  this.isloading().close;
                  goGame(item, this.$store.state.isLogin, this.$store.state.UUID)
                }else{
                  this.$router.push({ path: '/game/iframe', query: { ifrUrl:encodeURIComponent(gameUrl), ifrTitle: encodeURIComponent(this.ifrTitle), fromUrl: encodeURIComponent(this.$route.path) } })
                }
                return false
            } else {
              this.$router.push({ path: '/login' })
            }
          } else {
            this.$store.commit('setupholdInfo', maintainRemarks)
            this.$store.commit('setupholdShow', true) // 维护弹框
          }
        }else if(hasShowSubGame == 1){
          if (gameType === '1') { // 表示热门列表里面有属于电子的 跳转到电子选项
            this.$router.push({ path: '/gamelobby/egame', query: { platformCode,gameType:1 } })
          }else if (gameType === '2') {
              this.$router.push({ path: '/gamelobby/live', query: { platformCode,gameType:2 } })
          }else if (gameType === '3') {
              this.$router.push({ path: '/gamelobby/sports', query: { platformCode,gameType:3 } })
          }else if (gameType === '4') {
              this.$router.push({ path: '/gamelobby/lottery', query: { platformCode,gameType:4 } })
          }else if (gameType === '5') {
              this.$router.push({ path: '/gamelobby/fish', query: { platformCode,gameType:5 } })
          }else if (gameType === '6') {
              this.$router.push({ path: '/gamelobby/chess', query: { platformCode,gameType:6 } })
          }else if (gameType === '7') {
              this.$router.push({ path: '/gamelobby/Classic', query: { platformCode,gameType:7 } })
          } else if (gameType === '8') {
              this.$router.push({ path: '/gamelobby/bingo', query: { platformCode,gameType:8 } })
          } 
        }
       
      }

    },

    _getLists() {
      if (this.platformList.length > 0 && this.platformCode) {
        this._getSlotList()
        return
      }

      const gameType = this.gameType;

      if (sessionStorage.getItem(`gameTypeList${gameType}`)) {
          const data = JSON.parse(sessionStorage.getItem(`gameTypeList${gameType}`));
          this.dosthCallBack(data);
          return
      }

      let _ajax = null
      let params = {}
      if (this.$Cookies.get('UUID')) params.UUID = this.$Cookies.get('UUID') || window.localStorage.getItem('UUID')
      if (this.gameType === '-1') { // 热门
        _ajax = getHomeHotGameList
      } else { // 其他
        _ajax = getPlatformByPlatCode
        params = { gameType: this.gameType }
      }
      console.log('this.gameType', this.gameType)
      
      if (!_ajax) return
      _ajax(params).then(([data, err, res]) => {
        if (!err && data) {
          sessionStorage.setItem(`gameTypeList${gameType}`, JSON.stringify(data));
          this.dosthCallBack(data);
        }
      }, error => {
          this.finished = true
        })
    },

    dosthCallBack(data) {
      if (this.gameType === '-1') { // 热门
          this.list = this.showPart ? data.slice(0,10) : data
          // lotteryBuySwitch === '0' 彩票开启 platformCode === 'GT' 为彩票
          if (this.$store.state.linkList.lotteryBuySwitch === '0') this.list = this.list.filter((item) => (item.platformCode !== 'GT'))
      } else if (this.gameType === '1') { // 电子
          this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
          let slotItem = null
          if (this.platformCode) {
          slotItem = this.platformCodeString
          // const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
          // slotItem = this.platformList[$index]
          // this.platformList.splice($index, 1)
          // this.platformList.unshift(slotItem)
          }
          if (!slotItem) slotItem = this.platformList[0]
          this.handleSlotPlat(slotItem)
      } else if (this.gameType === '7' ||this.gameType === '8') { //经典
          this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
          let slotItem = null
          if (this.platformCode) {
          slotItem = this.platformCodeString
          // const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
          // slotItem = this.platformList[$index]
          // this.platformList.splice($index, 1)
          // this.platformList.unshift(slotItem)
          }
          if (!slotItem) slotItem = this.platformList[0]
          this.handleSlotPlat(slotItem)
      } else if (this.gameType === '6') {
          this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
          let slotItem = null
          if (this.platformCode) {
          slotItem = this.platformCodeString
          // const $index = this.platformList.findIndex((item) =>(item.platformCode === this.platformCode))
          // slotItem = this.platformList[$index]
          // this.platformList.splice($index, 1)
          // this.platformList.unshift(slotItem)
          }
          if (!slotItem) slotItem = this.platformList[0]
          this.handleSlotPlat(slotItem)
      }else if (this.gameType === '5') {
          this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
          let slotItem = null
          if (this.platformCode) {
          slotItem = this.platformCodeString
          }
          if (!slotItem) slotItem = this.platformList[0]
          this.handleSlotPlat(slotItem)
      }else if (this.gameType === '2') {
          this.platformList = [{fullName: this.$t('ekgamehistory.Allproviders'), platformCode: ''},...data.list]
          let slotItem = null
          if (this.platformCode) {
          slotItem = this.platformCodeString

          }
          if (!slotItem) slotItem = this.platformList[0]
          this.handleSlotPlat(slotItem)
      } else { // 其他
          this.list = data.list
          this.total = data.total
          if(this.total < this.pages.pageSize){
          this.nowNumber = this.total
          }else{
          this.nowNumber = this.list.length
          }
      }
      this.loadingData = false;
    },

    goNextPage() { // 下一页
      this.pages.pageNo += 1
      if (this.gameType === '1'|| this.gameType === '2' || this.gameType === '5' || this.gameType === '6' || this.gameType === '7' || this.gameType === '8'){
          this._getSlotList() // 电子
      }
    },
    _getSlotList(keyword) { // 获取电子列表
      if (keyword !== undefined || keyword === false) this.pages.pageNo = 1
      let slotSel = null
      if (this.platformCodeString) {
        slotSel = this.platformCodeString
      }
      if (slotSel != null) {
        if(this.platformList){
          if (this.platformCodeString) {
            slotSel = this.platformCodeString
          }else{
              slotSel = this.platformList[0].platformCode;
          }
        }else{
          slotSel = '';
        }
      }else{
        slotSel = '';
      }
      const params = { gameType: this.gameType, platformCode: slotSel, ...this.pages, hotOrNew: this.queryType }
      if (this.$store.state.isLogin) params.UUID = this.$store.state.UUID
      if (keyword && keyword.length > 0) {
        params.keyword = keyword
        this.pages.pageNo = 1
        this.list = []
      }
      let strKey = ''
      for (const key in params) {
          strKey+=`${key}-${encodeURIComponent(params[key])}`
      }
      if (sessionStorage.getItem(`${strKey}`)) {
          const data = JSON.parse(sessionStorage.getItem(`${strKey}`));
          this.gameListCallBack(data);
          return
      }
     // if (this.pages.pageNo === 1) this.loadmore = true
      getAllGameList(params).then(([data, err, res]) => {
        //this.finish()
        if (!err) {

          this.gameListCallBack(data);
          sessionStorage.setItem(`${strKey}`, JSON.stringify(data));
          
        } else {
          this.finished = true;
        }
      })
    },

    gameListCallBack(data) {
      const { list, total, hasNextPage } = data
      if (hasNextPage === true) {
          this.hasNextPage = true;
          this.list = this.pages.pageNo === 1 ? list : [...this.list, ...list]
      }else{
          this.hasNextPage = false;
          this.list = [...this.list, ...list]
      }
      this.total = total
      if(this.total < this.pages.pageSize ){
          this.nowNumber = this.total
          }else{
          this.nowNumber =  this.list.length
      }
    }

  },
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/game/index.vue